import { createApp } from 'vue'
import PageEditor from './PageEditor.vue'
import '@/lib/hydrateStripes/index'

// The version history preview (see AdminVersionHistory.vue) renders a whole
// page, this script included, in an iframe. That page only needs its stripes
// hydrated, not an editor of its own.
function isVersionPreviewFrame() {
  return !!window.frameElement?.hasAttribute('data-vssl-version-preview')
}

if (!isVersionPreviewFrame()) {
  const app = createApp(PageEditor)

  let el = document.getElementById('vssl-page-editor')
  if (!el) {
    el = document.createElement('div')
    el.id = 'vssl-page-editor'
    document.body.appendChild(el)
  }

  app.mount(el)
}
